(function () {
    'use strict';

    function main() {
        var page = wo$('#share-phone-finder');
        if (!page.length) return;
        var data = WhistleOut.readLookupData(page);

        var controller = {
            init: function () {
                page.find('#embed-code, #share-url')
                    .off('click')
                    .click(function () {
                        WhistleOut.focusAndSelect(this, true);
                        WhistleOut.triggerPopoverNotification(this, data.resources.copied, 'bottom');
                    });

                page.on('show.bs.modal', function () {
                    var url = WhistleOut.replaceQueryString(data.embedInfoUrl, location.search);
                    wo$.ajax({
                        type: 'GET',
                        url: url,
                        async: true
                    })
                        .done(function (updatedData) {
                            data = updatedData;
                            controller.updateShareUrl();
                        })
                        .always(function () {
                            controller.updatePreview(true);
                        });
                    if (page.find('input#showWidgetCode').length) {
                        page.find('input#showWidgetCode').prop('checked', false);
                        page.find('input#embed-code').addClass('hidden');
                    }
                });

                page.find('input#showWidgetCode').change(function () {
                    if (this.checked) {
                        page.find('input#embed-code').removeClass('hidden');
                        page.find('input#embed-code').click();
                    } else {
                        page.find('input#embed-code').addClass('hidden');
                    }
                });

                page.find('#compact')
                    .off('click')
                    .on('click', function () {
                        controller.updatePreview(true);
                    });

                page.find('[data-update]').on('change', function () {
                    controller.updatePreview(true);
                });

                page.find('#amp')
                    .off('click')
                    .on('click', function () {
                        controller.updatePreview(false);
                    });

                page.find('#short-url')
                    .off('click')
                    .click(function () {
                        controller.updateShareUrl();
                        WhistleOut.focusAndSelect(wo$('#share-url'));
                    });

                wo$(window).on('message', function (event) {
                    if (
                        event.originalEvent.data &&
                        Object.prototype.hasOwnProperty.call(event.originalEvent.data, 'sentinel') &&
                        event.originalEvent.data.sentinel === 'whistleout-widget'
                    ) {
                        page.find('#embed-preview').height(event.originalEvent.data.height);
                    }
                });
            },

            updatePreview: function (refreshWidget) {
                try {
                    var code;
                    var compact = page.find('#compact').is(':checked');
                    var amp = page.find('#amp').is(':checked');

                    var maxNumberOfResults = page.find('#max-results').val();

                    var query = '';

                    query = WhistleOut.updateQueryStringParameter(query, 'n', maxNumberOfResults);

                    if (compact) {
                        query = WhistleOut.updateQueryStringParameter(query, 'layout', 'Compact');
                    }

                    var embedAmpUrl = (data.embedAmpUrl + query).replace(/&/g, '&amp;');
                    var embedIFrameUrl = (data.embedIFrameUrl + '?' + query).replace(/&/g, '&amp;');
                    if (amp) {
                        code = data.embedAmpFormatString.replace('{ampurl}', embedAmpUrl);
                    } else {
                        var embedUrl = data.embedUrl + query;
                        if (data.encode) embedUrl = embedUrl.replace(/&/g, '&amp;');
                        code = data.embedFormatString
                            .replace('{url}', embedUrl)
                            .replace('{ampurl}', embedAmpUrl)
                            .replace('{iframeurl}', embedIFrameUrl);
                    }

                    page.find('#embed-code').val(code).css('background-color', 'rgba(255,255,0,.3)').animate(
                        {
                            backgroundColor: 'white'
                        },
                        2000
                    );

                    if (refreshWidget) {
                        var previewUrl = WhistleOut.updateQueryStringParameter(
                            data.previewUrl,
                            'maxresults',
                            maxNumberOfResults
                        );
                        if (compact) {
                            previewUrl = WhistleOut.updateQueryStringParameter(previewUrl, 'layout', 'Compact');
                        }
                        page.find('#embed-preview').attr('src', previewUrl);
                    }
                } catch (e) {
                    // TODO: Log error?
                }
            },

            updateShareUrl: function () {
                var url = page.find('#short-url').is(':checked') ? data.shareShortUrl : data.shareUrl;
                page.find('#share-url').val(url);
            }
        };

        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
